import { Pipe, PipeTransform } from '@angular/core';
import { COUNTRIES } from '@/_constants';

/** Resolves ISO 3166-1 alpha-2 codes to display labels (same source as telco geography). */
@Pipe({
  name: 'countryIsoToLabel',
  standalone: true
})
export class CountryIsoToLabelPipe implements PipeTransform {
  transform(code: string | null | undefined): string {
    if (code == null || String(code).trim() === '') {
      return '';
    }
    const upper = String(code).trim().toUpperCase();
    const hit = COUNTRIES.find((c) => c.value.toUpperCase() === upper);
    return hit?.label ?? String(code);
  }
}
